import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, Typography, useMediaQuery } from '@mui/material';
import styles from '../../devotee.module.scss';
import {
   LeftAndRightStyledIconsButton,
   CommonButton,
   HcccCard,
} from '../../../common/StyledComponents/StyledFields';
import { useEffect, useState } from 'react';
import commonStyles from '../../../../App.module.scss';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../../../infrastructure/backendService';
import EmptyPage from '../../../common/emptyPages/emptyPage';
import ToastComponent from '../../../common/toastComponent';
import apiPath from "../../../../config/apiPaths.json";
import { CustomTooltip } from '../../../common/muhurtham/muhurtham';
import { RoutingURLs } from '../../../common/RoutingURLs';

export default function ActionAreaCard() {
   const [currentIndex, setCurrentIndex] = useState(0);
   const [myFavorateList, setmyFavorateList] = useState<any[]>([]);
   const userName = sessionStorage.getItem("username");
   const isMobile = useMediaQuery('(max-width:600px)'); 

   const cardsPerPage = isMobile ? 1 : 4;

   useEffect(() => {
      apiRequest({
         method: 'GET',
         endpoint: apiPath.favouritesEventsApi,
         params: {
            username: userName,
         },
         includeToken: true,
      })
         .then((res) => {
            setmyFavorateList(res.data);
         })
         .catch((err) => {
            console.log(err);
            // toast.error(`${err.message}`);
            setmyFavorateList(myFavorateList); // comment this line after getting response 200 from the server
         })
   }, [])

   const navigate = useNavigate();

   const previousSlide = () => {
      setCurrentIndex((prevIndex) => (prevIndex - cardsPerPage < 0 ? 0 : prevIndex - cardsPerPage));
  };

  const nextSlide = () => {
      setCurrentIndex((prevIndex) => {
          const nextIndex = prevIndex + cardsPerPage;
          if (nextIndex >= myFavorateList.length) {
              return prevIndex;
          }
          return nextIndex;
      });
  };

   const handleDonateButton = (event_id : string): void => {
      navigate(`${RoutingURLs.donations}?donationID=${event_id}`)
   };
   const filteredData = myFavorateList.filter(event => event.poojaOrDonationName);


   const renderWithData = () => {
      return (
         <>
            <div className={styles.MyFavourateLayout}>
               <LeftAndRightStyledIconsButton
                  className={styles.carouselButton}
                  style={currentIndex === 0 ? { backgroundColor: '#FFF9E4' } : {}}
                  onClick={previousSlide}
                  disabled={currentIndex === 0}
               >
                  <ChevronLeftIcon />
               </LeftAndRightStyledIconsButton>
               <div className={styles.imageContainer}>
                  {filteredData.slice(currentIndex, currentIndex + cardsPerPage).map((card) => (
                     <HcccCard
                        key={card.poojaOrDonationName}
                        className={styles.Card_N_Image}
                     >
                        <Box className={styles.dataContainer}>
                           {card.imagePath && card.imagePath.trim() !== "" && card.imagePath !== "<>" ? (
                              <img className={styles.image} src={card.imagePath} alt={card.poojName} />
                           ) : (
                              <img className={styles.image} src="/images/LordShiva.svg" alt={card.poojName} />
                           )}
                           <CustomTooltip title={card.poojaOrDonationName} placement="top-start" arrow>
                              <Typography className={styles.cardText}>
                                 {card.poojaOrDonationName.length > 30
                                    ? `${card.poojaOrDonationName.slice(0, 30)}...`
                                    : card.poojaOrDonationName}
                              </Typography>
                           </CustomTooltip>
                           <CustomTooltip title={card.dietyName} placement="top-start" arrow>
                              <Typography className={styles.cardText}>
                                 {card.dietyName && card.dietyName.length > 30
                                    ? `${card.dietyName.slice(0, 30)}...`
                                    : card.dietyName || ""}
                              </Typography>
                           </CustomTooltip>
                           <Box>
                              <CommonButton
                                 onClick={() => handleDonateButton(card?.donationOrPoojaId)}
                              >
                                 Donate
                              </CommonButton>
                           </Box>
                        </Box>
                          </HcccCard>
                      ))}
                  </div>
                  <LeftAndRightStyledIconsButton
                      className={styles.carouselButton}
                      style={currentIndex + cardsPerPage >= myFavorateList.length ? { backgroundColor: '#FFF9E4' } : {}}
                      onClick={nextSlide}
                      disabled={currentIndex + cardsPerPage >= myFavorateList.length}>
                      <ChevronRightIcon />
                  </LeftAndRightStyledIconsButton>
              </div>
          </>
      )
  };

   const renderEmptyData = () => {
      return (
         <>
            <EmptyPage
               imgUrl="/svg/myFavouriteEmpty.svg"
               typographyText="No Favourite Events"
            />
         </>
      );
   };

   return (
      <div>
         <ToastComponent />
         <h3 className={commonStyles.sectionTitle}>Favorite Events</h3>
         {myFavorateList.length === 0 ? renderEmptyData() : renderWithData()}
      </div>
   );
}
